var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _foreignObject;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStickyNote3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 141,
    viewBox: "0 0 137 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3093 3.52637C31.3093 8.95556 31.818 25.2352 31.818 19.806",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4101 4.03491C95.4101 5.59731 94.8396 8.07517 96.4275 9.00925C97.4673 9.62089 96.9363 13.0486 96.9363 14.2097C96.9363 16.4455 98.9471 21.0009 96.4275 21.8408",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0883 20.9027L96.4274 21.8408",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3093 2L95.2322 3.39751",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.1654H29.9742",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2103 11.1842H135",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M134.619 10.8998L132.118 139.063",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.07938 12.1501L3.32975 139.063",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.32974 138.438L132.055 138.786",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.51912 15.7175V33.6052",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.89415 17.7427V23.1427",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2692 16.3927V21.1177",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M128.033 17.7427V36.9803",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M124.32 17.405V21.7926",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M119.595 18.0802V22.8052",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M126.008 113.931V133.506",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M120.945 127.094V132.831",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M116.22 129.793V132.493",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55713 119.668V134.856",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5939 129.118V135.193",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M14.632 133.506V135.869",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _foreignObject || (_foreignObject = /*#__PURE__*/React.createElement("foreignObject", {
    x: 0,
    y: 0,
    width: 137,
    height: 141
  }, /*#__PURE__*/React.createElement("p", {
    id: "sticky-note-3",
    xmlns: "http://www.w3.org/1999/xhtml"
  }, "\r\n            We can have an online call right now\r\n        "))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStickyNote3);
export default __webpack_public_path__ + "static/media/sticky-note-3.f07c031037411cfbbb72f442a111146a.svg";
export { ForwardRef as ReactComponent };